export const SENTRY_TRACES_SAMPLE_RATE = {
  production: 0.2,
  development: 1,
} as const

export const SENTRY_TRACE_PROPAGATION_TARGETS: Array<string | RegExp> = [
  'localhost',
  /^https:\/\/maaliondoor-backend-prod-6573o6ksgq-ew\.a\.run\.app/,
]

export const SENTRY_REPLAY_SAMPLE_RATE = {
  session: 0.1,
  onError: 1,
} as const

export const SENTRY_ERROR_FALLBACK = {
  title: 'Something went wrong',
  hint: 'Please refresh the page and try again.',
} as const
